import { component, demoFile } from 'system/demo';

import { PushPermissionPopup } from '../pushNotifs';

demoFile('open-modules/zdf/platform-specific/pushPermissionPopup');

component('PushPermissionPopup', PushPermissionPopup, { args: { onAllow: () => {}, onNotAllow: () => {} } });
